import { EventRegistry } from '../../../../../domain/event/event.registry';
import { AssetEvent } from './asset.event';
export class LegacyPhotosLinkedToAssetEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset-class/${payload.assetClassId}/asset/${payload.id}`,
            type: LegacyPhotosLinkedToAssetEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
LegacyPhotosLinkedToAssetEvent.type = 'com.treeplotter.api.photo.legacyPhotosLinkedToAsset.v1';
EventRegistry.register(LegacyPhotosLinkedToAssetEvent.type, LegacyPhotosLinkedToAssetEvent);
//# sourceMappingURL=legacy-photos-linked-to-asset.event.js.map